import React from 'react';

import { UserAvatar, Text } from '@common/components';
import Auth, { AccountInfoType } from 'works/legacy/lib/auth';
import { Colors, FontSize, FontWeight, LineHeight } from '@common/tokens';
import { AccountAvatar } from '@identity/components';

import { AccountItem } from './_account-item';

export const AccountLeading = ({
  current,
}: {
  current: AccountInfoType | undefined;
}) => (
  <div className="account-leading">
    <AccountItem mode="appbar">
      <>
        <UserAvatar
          textAsInitials={Auth.name()}
          backgroundColor={Colors.elmDarkest}
        />
        {current && (
          <span className="stacked-avatar">
            <AccountAvatar account={current} size={40} />
          </span>
        )}
      </>
      <>
        <Text className="body-medium-medium">{Auth.entityName()}</Text>
        <Text className="body-small-book" secondary>
          {Auth.membershipRole()}
        </Text>
      </>
    </AccountItem>
    <style jsx>{`
      .account-leading {
        text-wrap: nowrap;
      }
      .account-leading :global(.stacked-avatar) {
        margin-left: -12px;
      }
      .account-leading :global(.body-medium-medium) {
        line-height: ${LineHeight.sm};
        font-weight: ${FontWeight.medium};
      }
      .account-leading :global(.body-small-book) {
        font-size: ${FontSize.xs};
        line-height: ${LineHeight.xs};
        font-weight: 400;
      }
    `}</style>
  </div>
);
